import { Component, OnInit, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OregonWellDataService } from '../../../services/oregon-well-data.service';
import { VoucherService } from '../../../services/voucher-service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

/*
 * Edit Voucher Dialog
 */
@Component({
    selector: 'dialog-voucher-edit',
    templateUrl: 'voucher-edit-dialog.html',
    styleUrls: ['./voucher-edit-dialog.scss']
  })
  export class DialogEditVoucherComponent implements OnInit  {
    loading: boolean = false;
    processing: boolean = false;
    voucherId: number = 0;
    voucherForm = new FormGroup({
      applicationStatus: new FormControl('', Validators.required),
      applicantContactName: new FormControl(''),
      applicantAddress: new FormControl(''),
      applicantCity: new FormControl(''),
      applicantState: new FormControl(''),
      applicantZip: new FormControl(''),
      applicantContactPhone: new FormControl(''),
      applicantContactEmail: new FormControl(''),
      voucherMaxValue: new FormControl(''),
      redeemed: new FormControl(false),
      exceedencesDetected: new FormControl(false),
      preferredContactComments: new FormControl(''),
      preferredContactType: new FormControl(''),
    });
      
    constructor(public oregonWellDataService: OregonWellDataService, 
                public voucherService: VoucherService, 
                private toastr: ToastrService, 
                @Inject(MAT_DIALOG_DATA) public data: number,
                private dialogRef: MatDialogRef<DialogEditVoucherComponent>) {
                  this.voucherId = this.data;
    }

    ngOnInit(): void {       
      // ngOnInit   
    }
  }